<script>
    export let type;
    export let additionalClass = '';
</script>

<button class="e_consent__btn e_consent__btn--{type} {additionalClass}" on:click|preventDefault>
    <slot></slot>
</button>

<style>
    :global(.e_consent__btn) {
        margin-bottom: 4px;
        margin-right: 4px;
        appearance: none;
        display: inline-block;
        border: 0 none;
        line-height: 18px;
        font-size: 14px;
        cursor: pointer;
        padding: 11px 20px;
        width: 100%;
        text-align: center;
        border-radius: 7px;
        transition: all 0.2s ease;
    }

    :global(.e_consent.e_consent--theme-overlay .e_consent__btn) {
        background-color: #f2f2f2;
        border-radius: 4px;
        color: #888;
        flex-shrink: 1;
        font-size: 18px;
        height: 50px;
        line-height: 24px;
        min-height: 50px;
        padding: 11px 30px;
        width: auto;
    }

    :global(.e_consent.e_consent--theme-overlay .e_consent__btn--save) {
        flex: 100%;
        margin-bottom: 15px;
    }

    :global(.e_consent__btn + a) {
        margin-left: auto;
        float: right;
    }

    :global(.e_consent__btn:last-child) {
        margin-right: 0;
    }

    /* THEME: bottom */
    :global(.e_consent.e_consent--theme-bottom .e_consent__btn--link) {
        padding: 0;
        color: #0f6dff;
        border-radius: 0;
        border: 0;
        background-color: transparent !important;
        width: auto;
        font-size: 12px;
        min-height: 0;
    }

    :global(.e_consent.e_consent--theme-bottom .e_consent__btn--accept),
    :global(.e_consent.e_consent--theme-bottom.e_consent--view-advanced .e_consent__btn--save),
    :global(.e_consent.e_consent--theme-bottom.e_consent--view-detailed .e_consent__btn--save) {
        color: white;
        -webkit-text-fill-color: white;
        background-color: #168933;
    }

    :global(.e_consent.e_consent--theme-overlay .e_consent__btn--link) {
        color: #52627c !important;
        background-color: transparent !important;
        width: auto;
        line-height: 24px;
        height: auto;
        min-height: 0;
        flex-basis: 100%;
        border: 1px solid currentColor;
        margin: 15px 0;
        text-align: center;
        padding: 8px 26px;
        font-size: 14px;
        font-weight: normal;
        border-radius: 4px;
    }

    :global(.e_consent.e_consent--theme-overlay .e_consent__btn:hover),
    :global(.e_consent.e_consent--theme-overlay .e_consent__btn:focus) {
        background-color: #dedede;
    }

    :global(.e_consent.e_consent--theme-overlay .e_consent__btn--accept) {
        background-color: #0163e4;
        border: 0;
        color: #fff;
    }

    :global(.e_consent.e_consent--theme-overlay .e_consent__btn--accept:hover),
    :global(.e_consent.e_consent--theme-overlay .e_consent__btn--accept:focus) {
        background-color: #AD0067;
    }

    :global(footer .e_consent__btn--accept) {
        padding: 12px 26px;
        font-size: 14px;
        font-weight: normal;
        border-radius: 4px;
        line-height: normal;
        margin: 0;
        flex-basis: 100%;
        text-transform: uppercase;
        background-color: #AD0067;
    }

    :global(footer .e_consent__btn--decline) {
        width: 100%;
        margin-bottom: 15px;
    }

    @media (max-width: 580px) {
        :global(.e_consent.e_consent--theme-overlay .e_consent__btn--save) {
            padding: 11px 30px;
            min-height: 32px;
            height: auto;
            line-height: 24px;
            margin-bottom: 12px;
            border-width: 1px;
            font-size: 18px;
        }
    }

    :global(.e_consent.e_consent--theme-overlay .e_consent__btn--decline) {
        position: absolute;
        top: 0;
        right: 0;
        background-color: transparent !important;
        color: #595959;
        padding: 10px 18px;
        z-index: 1;
        height: auto;
        min-height: 0;
        text-align: right;
        line-height: 16px;
        width: auto;
        font-size: 11px;
    }
</style>
